import { deleteAdhocItem } from "@/api/adhoc-items";
import { Button } from "@/components/ui/button";
import {
  AdhocItem,
  AdhocItemType,
  AdhocItemTypeLabels,
} from "@/models/adhoc-items.model";
import { ColumnDef } from "@tanstack/react-table";

const ActionCell = ({
  row,
  deleteAdhocItemCallback,
}: {
  row: any;
  deleteAdhocItemCallback: (id: number) => void;
}) => {
  const handleDeleteAdhocItem = async () => {
    try {
      const res = await deleteAdhocItem(row.original.id);

      if (res) {
        deleteAdhocItemCallback(row.original.id);
      }
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <Button variant="outline" onClick={handleDeleteAdhocItem}>
      Delete
    </Button>
  );
};
export const getColumns = (
  deleteAdhocItem: (id: number) => void
): ColumnDef<AdhocItem>[] => [
  {
    accessorFn: (row) => row.type,
    cell: ({ row }) => {
      return (
        <span>{AdhocItemTypeLabels[row.original.type as AdhocItemType]}</span>
      );
    },
    header: "Type",
  },
  {
    accessorFn: (row) => row.amount,
    cell: ({ row }) => {
      return <span>{row.original.amount}</span>;
    },
    header: "Amount ($)",
  },
  {
    header: "Actions",
    cell: ({ row }) => (
      <ActionCell deleteAdhocItemCallback={deleteAdhocItem} row={row} />
    ),
  },
];
